<template lang="pug">
#episodes-tab
  spinner(v-if="!settings.loaded || settings.loading")
  div(v-else)
    div(v-if="episodes.length > 0")
      .columns.is-multiline.episodes
        .column.is-one-third-desktop.is-one-third-widescreen(
          v-for="episode in episodes"
          :key="episode.id"
        )
          episode-list-item(
            :hoverable="true"
            :value="episode"
            type="thumbnail"
          )
    .notification.has-text-centered.goose-egg(v-else) No services match the selected filters
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'episodes-tab',
  components: {
    EpisodeListItem,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      channels: getterTypes.GET_CHANNELS,
      episodes: getterTypes.GET_EPISODES,
      filters: getterTypes.GET_SERVICES_FILTERS,
      mode: getterTypes.GET_SERVICES_MODE,
      nextPage: getterTypes.GET_SERVICES_NEXT_PAGE,
      pagination: getterTypes.GET_EPISODES_PAGINATION,
      refresh: getterTypes.GET_SERVICES_REFRESH,
    }),
    channelIds() {
      if (!this.channels) return [];
      return _.map(this.channels, 'id');
    },
    esQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const today = moment().format('YYYY-MM-DD');
      const payload = {
        from: from >= 0 ? from : 0,
        size: this.pagination.per,
        sort: {
          pub_date: { order: 'desc' },
          'title.raw': { order: 'asc' },
        },
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { terms: { channel_ids: this.channelIds } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: today } } },
            ],
            must_not: [],
            should: [],
          },
        },
      };
      if (this.filters.channels.length > 0) {
        payload.query.bool.must.push({ terms: { channel_ids: this.filters.channels } });
      }
      if (this.filters.speakers.length > 0) {
        payload.query.bool.must.push({ terms: { '_embedded.speaker.id': this.filters.speakers } });
      }
      if (this.filters.query) {
        const lowercase = this.filters.query.toLowerCase();
        payload.query.bool.must.push({
          bool: {
            should: [
              { match_phrase_prefix: { title: lowercase } },
              { match_phrase_prefix: { '_embedded.channels.title': lowercase } },
              { match_phrase_prefix: { '_embedded.speaker.full_name': lowercase } },
            ],
          },
        });
      }
      // TODO tags
      if (this.filters.years) {
        const yearFilters = {
          bool: {
            should: [],
          },
        };
        this.filters.years.forEach((year) => {
          const gte = `${year.id}-01-01`;
          const lte = `${year.id}-12-31`;
          yearFilters.bool.should.push({ range: { pub_date: { gte, lte } } });
        });
        payload.query.bool.must.push(yearFilters);
      }
      return payload;
    },
    morePages() {
      if (this.pagination.total === 0) return false;
      return Math.ceil(this.pagination.total / this.pagination.per) > this.pagination.page;
    },
  },
  created() {
    if (this.episodes.length === 0) {
      this.settings.loading = true;
      this.getPage(1);
    } else {
      this.settings.loaded = true;
    }
  },
  data() {
    return {
      settings: {
        loading: false,
        loaded: false,
      },
    };
  },
  methods: {
    async getPage(page, options) {
      this.$store.commit(mutationTypes.SET_EPISODES_PAGINATION_FIELD, {
        key: 'page',
        val: page,
      });
      const payload = Object.assign(options || {}, this.esQuery);
      const response = await this.$store.dispatch(actionTypes.DO_GET_EPISODES, payload);
      this.$store.commit(mutationTypes.SET_EPISODES_PAGINATION_FIELD, {
        key: 'total',
        val: response.hits.total,
      });
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, false);
      this.$store.commit(mutationTypes.SET_SERVICES_NEXT_PAGE, false);
      this.settings.loading = false;
      this.settings.loaded = true;
      return response;
    },
  },
  watch: {
    nextPage(val) {
      if (val && this.mode === 'sermons') {
        if (this.morePages) {
          this.getPage(this.pagination.page + 1, { method: 'append' });
        } else {
          this.$store.commit(mutationTypes.SET_SERVICES_NEXT_PAGE, false);
        }
      }
    },
    refresh(val) {
      if (val) {
        this.settings.loading = true;
        this.getPage(1);
      }
    },
  },
};
</script>

<style lang="scss">

</style>
